function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden-mobile');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove('overflow-hidden-mobile');
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden-mobile');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup')?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);


class HeaderContainer extends HTMLElement {
  constructor() {
    super();

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 37) {
      if (!this.classList.contains('header--scrolled')) {
        this.classList.add('header--scrolled');
      }
    }
  }

  onScroll() {
    if (this.classList.contains('header--transparent')) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 37) {
        if (!this.classList.contains('header--scrolled')) {
          this.classList.add('header--scrolled');
        }
      } else{
        if (this.classList.contains('header--scrolled')) {
          this.classList.remove('header--scrolled');
        }
      }

      this.currentScrollTop = scrollTop;
    }
  }
}

customElements.define('header-container', HeaderContainer);

// Product Card
class ProductCard extends HTMLElement {
  constructor() {
    super();   

    // Swatch
    this.swatch = $('.card-information__swatch');
    this.swatch.off('click').click(this.handleSwatchClick.bind(this));
  }

  handleSwatchClick(e) {
    e.preventDefault();

    const variantUrl = $(e.currentTarget).data('variantUrl');
    console.log(variantUrl)
    const variantId = $(e.currentTarget).data('variantId');
    const imageUrl = $(e.currentTarget).data('imageUrl');
    const color = $(e.currentTarget).data('value');

    this.swapImage(e, imageUrl, color);
    this.changeActiveState(e, color);
    this.swapLinks(e, variantUrl, variantId);
  }

  swapImage(e, imageUrl, color) {
    if (imageUrl) {
      $(e.currentTarget)
        .closest('.card-information')
        .siblings('.card')
        .find('.media img:first-of-type')
        .attr('alt', color)
        .attr('srcset', imageUrl)
        .attr('src', imageUrl);
    }
  }

  changeActiveState(e, color) {
    // Select new swatch
    $(e.currentTarget).siblings().removeClass('active');
    $(e.currentTarget).addClass('active');

    // Change active text
    $(e.currentTarget)
      .closest('.card-information__variants')
      .siblings('.card-information__selected-color')
      .text(color);
  }

  swapLinks(e, variantUrl, variantId) {
    $(e.currentTarget)
      .closest('.card-wrapper')
      .find('.card__link')
      .attr('href', variantUrl);
  }
}

customElements.define('product-card', ProductCard);

// Parallax
if ($('.rellax').length) {
  var rellax = new Rellax('.rellax');
}

// init AOS
$(function() {
  AOS.init({
    duration: 1000,
    once: true
  });
});

// Sliders
$('.collection-slider__slider').slick({
  slidesToShow: 3,
  prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="21" viewBox="0 0 32 21" fill="none"><path d="M10.8643 19.4018L10.0001 20.2529L0.00012207 10.4049L10.0001 0.556885L10.8643 1.40795L2.3458 9.79698H31.7285V11.0128H2.3458L10.8643 19.4018Z" fill="#3C3C3C"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="33" height="21" viewBox="0 0 33 21" fill="none"><path d="M21.5927 19.4018L22.4569 20.2529L32.4569 10.4049L22.4569 0.556885L21.5927 1.40795L30.1112 9.79698H0.728516V11.0128H30.1112L21.5927 19.4018Z" fill="#3C3C3C"/></svg></button>',
  appendArrows: $('.collection-slider__header-controls'),
  infinite: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        infinite: true,
        arrows: false,
        useTransform: false
      }
    }
  ]
});

$('.press-slider__quotes').slick({
  arrows: false,
  asNavFor: '.press-slider__logos',
  autoplay: true,
  autoplaySpeed: 5000,
  fade: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        useTransform: false
      }
    }
  ]
});

$('.press-slider__logos').slick({
  arrows: false,
  asNavFor: '.press-slider__quotes',
  centerMode: true,
  draggable: false,
  focusOnSelect: true,
  slidesToShow: 5,
  responsive: [
    {
      breakpoint: 1050,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        variableWidth: true,
        useTransform: false
      }
    }
  ]
});

$('.value-props__container').slick({
  arrows: false,
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000,
        useTransform: false
      }
    }
  ]
});

$('.featured-collection__products-slider').slick({
  arrows: false,
  appendDots: $('.featured-collection__product-slider-controls'),
  asNavFor: '.featured-collection__product-image-slider',
  dots: true,
  fade: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        fade: false,
        autoplay: true,
        useTransform: false
      }
    }
  ]
});

$('.featured-collection__product-image-slider').slick({
  arrows: false,
  asNavFor: '.featured-collection__products-slider',
  fade: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        useTransform: false
      }
    }
  ]
});

$('.celebrity-slider__slider').slick({
  slidesToShow: 2,
  prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="21" viewBox="0 0 32 21" fill="none"><path d="M10.8643 19.4018L10.0001 20.2529L0.00012207 10.4049L10.0001 0.556885L10.8643 1.40795L2.3458 9.79698H31.7285V11.0128H2.3458L10.8643 19.4018Z" fill="#3C3C3C"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="33" height="21" viewBox="0 0 33 21" fill="none"><path d="M21.5927 19.4018L22.4569 20.2529L32.4569 10.4049L22.4569 0.556885L21.5927 1.40795L30.1112 9.79698H0.728516V11.0128H30.1112L21.5927 19.4018Z" fill="#3C3C3C"/></svg></button>',
  appendArrows: $('.celebrity-slider__controls'),
  variableWidth: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        useTransform: false
      }
    }
  ]
});


$('.portfolio-slider__image-slider').slick({
  asNavFor: '.portfolio-slider__content-slider',
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        useTransform: false
      }
    }
  ]
});

$('.portfolio-slider__content-slider').slick({
  asNavFor: '.portfolio-slider__image-slider',
  prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="21" viewBox="0 0 32 21" fill="none"><path d="M10.8643 19.4018L10.0001 20.2529L0.00012207 10.4049L10.0001 0.556885L10.8643 1.40795L2.3458 9.79698H31.7285V11.0128H2.3458L10.8643 19.4018Z" fill="#3C3C3C"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="33" height="21" viewBox="0 0 33 21" fill="none"><path d="M21.5927 19.4018L22.4569 20.2529L32.4569 10.4049L22.4569 0.556885L21.5927 1.40795L30.1112 9.79698H0.728516V11.0128H30.1112L21.5927 19.4018Z" fill="#3C3C3C"/></svg></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        useTransform: false
      }
    }
  ]
});

    if (window.matchMedia('(max-width: 768px)').matches) {
       $('.collection-article .product-grid').slick({
  slidesToShow: 1,
arrows: false,
  infinite: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        infinite: true,
        arrows: false,
        useTransform: false
      }
    }
  ]
});
    } else {
       
    }



/* PDP Slider */
$('.product__media-list').slick({
  arrows: false,
  fade: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        fade: false,
        useTransform: false,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none"><path d="M5 1L1 5L5 9" stroke="#3C3C3C"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none"><path d="M1 1L5 5L1 9" stroke="#3C3C3C"/></svg></button>'
      }
    }
  ]
});

// Sync thumbnails with slider
$('.product__media-list').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  var slide = nextSlide;
  var mediaId = $(`.product__media-item[data-slick-index="${slide}"]`).data('mediaId');

  $('.product__slider-thumbnail-item').removeClass('active');
  $(`.product__slider-thumbnail-item[data-media-id="${mediaId}"]`).addClass('active');
});

// Sync slider with thumbnails
$('.product__slider-thumbnail-item').click(function() {
  var slide = $(this).data('mediaId');

  $('.product__slider-thumbnail-item').removeClass('active');
  $(this).addClass('active');

  var slidePosition = $(`.product__media-item[data-media-id="${slide}"]`).data('slickIndex');

  $('.product__media-list').slick('slickGoTo', slidePosition);
});

/* Bridal PDP Slider */
$('.bridal-product__slider').slick({
  arrows: false,
  fade: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        fade: false,
        useTransform: false,
        dots: true
      }
    }
  ]
});

// Sync thumbnails with slider
$('.bridal-product__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  var slide = nextSlide;
  var mediaId = $(`.bridal-product__slide-item[data-slick-index="${slide}"]`).data('mediaId');

  $('.bridal-product__thumbnail').removeClass('active');
  $(`.bridal-product__thumbnail[data-media-id="${mediaId}"]`).addClass('active');
});

// Sync slider with thumbnails
$('.bridal-product__thumbnail').click(function() {
  var slide = $(this).data('mediaId');

  $('.bridal-product__thumbnail').removeClass('active');
  $(this).addClass('active');

  var slidePosition = $(`.bridal-product__slide-item[data-media-id="${slide}"]`).data('slickIndex');

  $('.bridal-product__slider').slick('slickGoTo', slidePosition);
});

/* Press Mobile */
$('.press-template__card').click(function() {
  $('.press-template__card').removeClass('is-flipped');
  
  if (!$(this).hasClass('is-flipped')) {
    $(this).toggleClass('is-flipped');
  }
});

/* FAQ */
// FAQ Dropdown
$('.faq__item-header').click(function() {
  var $item = $(this).parent();
  var $content = $(this).siblings('.faq__item-content');

  if ($item.hasClass('active')) {
    $item.removeClass('active');
    $content.slideUp(300);
  } else {
    $item.addClass('active');
    $content.slideDown(300);
  }
});

// Highlight current faq section
$(window).scroll(function() {
  var headerHeight = $('.header-wrapper').outerHeight();

  $('.faq-header').each(function(i, el) {
    if ($(el).offset().top - headerHeight - 21 < $(window).scrollTop()) {
      var title = $(el).data('title');
      $('.faq__navigation button.btn-2').removeClass('active');
      $(`.faq__navigation button.btn-2[data-title="${title}"]`).addClass('active');

      $('.faq__navigation-selected span').text(title);
    }
  });
});

// Scroll To
$('.faq__navigation button.btn-2').click(function() {
  var title = $(this).data('title');
  var headerHeight = $('.header-wrapper').outerHeight();

  $('html, body').animate({
    scrollTop: $(`#${title}`).offset().top - headerHeight - 20
  });
});

/* Site Credits */
$('a[href="#credits"]').click(function() {
  $('.site-credits').fadeIn(300);
});

$('.site-credits__close').click(function() {
  $('.site-credits').fadeOut(300);
});

/* Legal popups */
function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

if (getCookie('legalCookie')){
  $('.legal-popup').fadeOut(400);
} else{
  $('.legal-popup').fadeIn(400);
}

$('.legal-popup__close').click(function () {
  var day = $('.legal-popup').attr('data-day');

  $('.legal-popup').fadeOut(400);
  setCookie('legalCookie', true, day)
});

// customer account
$('.customer-sidebar__menu > p').click(function() {
  let name = $(this).data('name')
  $('.customer-sidebar__menu > p').css('opacity','0.5')
  $('.customer-items').hide() 
  $(`.${name}`).show()
  $(this).css('opacity','1');
})

$('.add-address-show').click(function() {
  $('.address-form__overlay').show();
  $('#AddAddress').show();
})

$('.edit-address-show').click(function() {
  $('.address-form__overlay').show();
  $('.edit-address__form').show()
})

$(`.address-form__overlay, .addresses form button[type='reset']`).click(function() {
  $('.address-form__overlay').hide();
  $('#AddAddress').hide();
  $('.edit-address__form').hide()
})

$('.current-account-item').click(function() {
  $(this).next().slideToggle()
})


$('.account-dropdown__info p').click(function() {
  let divName = $(this).data('name');
  $('.customer-items').hide()
  $(`.${divName}`).show();
  $('.current-account-item p').text($(this).text())
  $('.account-dropdown__info').slideUp()
})
/* Zoom pdp */
// $('.product__media').zoom({magnify: 1.5, url: $(this).data('fullsize')});

// Zoom image on hover
// $('.product__media').each(function(i, el) {
//   $(el).zoom({magnify: 1.4, url: $(el).data('fullsize')});
// });

// Search bar
$('.search-button').click(function() {
  $('.search-button').hide();
  $('.header-search__bar').show();
});

$('.header-search .icon-close').click(function() {
  $('.search-button').show();
  $('.header-search__bar').hide();
});

// Press popup
$('.press-template__see-more').click(function(e) {
  var card = $(this).data('card');
  
  $('.press-template__card-popup-wrapper').removeClass('active');
  $(`.press-template__card-popup-wrapper[data-card="${card}"]`).addClass('active');
  $(`.press-template__card-popup-wrapper[data-card="${card}"] .button--close`).click(function() {
    $('.press-template__card-popup-wrapper').removeClass('active');
  });
  
  $(`.press-template__card-popup-wrapper[data-card="${card}"]`).click(function(e) {
    if ($(e.target).hasClass('press-template__card-popup-wrapper')) {
      $('.press-template__card-popup-wrapper').removeClass('active');
    }
  });
});

/* FUNCTIONS */
function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

function atcGetSectionsToRender() {
  return [
    {
      id: 'cart-drawer__content',
      section: document.getElementById('cart-drawer__content').dataset.id,
      selector: '.cart-drawer__content',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    }
  ];
}

// Add to cart
$('body').on('click', '.js-add-to-cart', function(e) {
  e.preventDefault();

  let id = Number($(this).data('id'));

  const body = JSON.stringify({
    items: [{
      id: id,
      quantity: 1
    }],
    sections: atcGetSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname
  });

  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then((response) => response.json())
    .then((parsedState) => {
      atcGetSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
          getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      }));
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      document.querySelector('cart-drawer').open();
    });
});

// Add to cart with refresh
$('body').on('click', '.js-add-to-cart-refresh', function(e) {
  e.preventDefault();

  let id = Number($(this).data('id'));

  const body = JSON.stringify({
    items: [{
      id: id,
      quantity: 1
    }]
  });

  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then((response) => response.json())
    .then((parsedState) => {

    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      location.reload();
    });
});

// Lightbox popup
document.addEventListener('DOMContentLoaded', () => {
  const zoomButtons = document.querySelectorAll('.product__media');
  if (!zoomButtons.length) return;

  const popup = document.getElementById('product-zoom-popup');
  const closeButton = document.getElementById('zoomPopupClose');
  const slickCarousel = document.querySelector('.product-zoom-popup__carousel');

  // Initialize Slick carousel
  $(slickCarousel).slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="21" viewBox="0 0 32 21" fill="none"><path d="M10.8643 19.4018L10.0001 20.2529L0.00012207 10.4049L10.0001 0.556885L10.8643 1.40795L2.3458 9.79698H31.7285V11.0128H2.3458L10.8643 19.4018Z" fill="#3C3C3C"></path></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="33" height="21" viewBox="0 0 33 21" fill="none"><path d="M21.5927 19.4018L22.4569 20.2529L32.4569 10.4049L22.4569 0.556885L21.5927 1.40795L30.1112 9.79698H0.728516V11.0128H30.1112L21.5927 19.4018Z" fill="#3C3C3C"></path></svg></button>',
  });

  // Open popup and navigate to the clicked image
  zoomButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      const index = e.currentTarget.dataset.index;
      
      // open popup
      popup.classList.add('active');

      // Go to the correct slide
      $(slickCarousel).slick('slickGoTo', index);
    });
  });

  // Close popup
  closeButton.addEventListener('click', () => {
    popup.classList.remove('active');
  });

  // On click zoom in
  const carouselImages = document.querySelectorAll('.product-zoom-popup__carousel img');

  carouselImages.forEach((image) => {
    // Track zoom state
    let isZoomed = false;

    image.addEventListener('click', (e) => {
      if (!isZoomed) {
        // Enable zoom
        const rect = image.getBoundingClientRect();
        const offsetX = e.clientX - rect.left;
        const offsetY = e.clientY - rect.top;

        const width = image.offsetWidth;
        const height = image.offsetHeight;

        const xPercent = (offsetX / width) * 100;
        const yPercent = (offsetY / height) * 100; 

        image.style.transform = 'scale(2)';
        image.style.transformOrigin = `${xPercent}% ${yPercent}%`;
        isZoomed = true;
      } else {
        // Reset zoom
        image.style.transform = 'scale(1)';
        image.style.transformOrigin = 'center center';
        image.parentElement.style.backgroundImage = 'none';
        isZoomed = false;
      }
    });
  });

});
